<template>
<div>
    <line-chart :data="gdata" :discrete="true" ytitle="Total Scores" :download="{ background: 'white' }" xtitle="Attempts"></line-chart>
</div>
</template>

<script>
// import {
//     mapState
// } from "vuex";

export default {
    props : ['gdata'],
    created() {
        // this.data = this.gdata;
    },
    // watch : {
    //     gdata(){
    //         this.data = this.gdata
    //     }
    // },
    data() {
        return {
            lineData: [{
                name: "Perfomance Curve",
                data: {
                    0: 0,
                    5: 4,
                    13: 20,
                    15: 25,
                    20: 15,
                    30: 20,
                    40: 75,
                    60: 50
                }
            }]
        };
    },

    computed: {
    }
};
</script>

<style scoped></style>
